<template>
<svg xmlns="http://www.w3.org/2000/svg" :fill="useCurrentColor ? 'currentColor' : '#000'" viewBox="0 0 12 12" :class="[`${prefix}-icon`, `${prefix}-icon-uploadFill`]" width="1em" height="1em" v-bind="$attrs"><path d="M6,0C2.67857,0,0,2.67857,0,6C0,9.32143,2.67857,12,6,12C9.32143,12,12,9.32143,12,6C12,2.67857,9.32143,3.37192e-7,6,0ZM8.52857,5.65714C8.35714,5.82857,8.07857,5.82857,7.90714,5.65714L6.42857,4.17857L6.42857,8.85C6.42857,9.08571,6.23571,9.27857,6,9.27857C5.76429,9.27857,5.57143,9.08571,5.57143,8.85L5.57143,4.17857L4.09286,5.65714C3.92143,5.82857,3.64286,5.82857,3.47143,5.65714C3.3,5.48571,3.3,5.20714,3.47143,5.03571L5.7,2.80714C5.87143,2.63571,6.15,2.63571,6.32143,2.80714L8.55,5.03571C8.7,5.20714,8.7,5.48571,8.52857,5.65714Z"/></svg>
</template>
<script>

export default {
  name: 'IconUploadFill',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
